// Requêtes fetch vers les endpoints JSON, hors navigation Inertia.
//
// Le jeton CSRF vient du cookie XSRF-TOKEN, rafraîchi par inertia_rails à
// chaque réponse : la balise <meta name="csrf-token"> n'est rendue qu'au
// premier chargement et devient périmée après une connexion ou une
// déconnexion faite sans recharger la page.

export function csrfToken(): string {
  const match = document.cookie.match(/(?:^|;\s*)XSRF-TOKEN=([^;]+)/)
  if (match) return decodeURIComponent(match[1])
  return document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')?.content || ''
}

type JsonInit = Omit<RequestInit, 'body'> & { body?: unknown; json?: boolean }

/**
 * fetch avec les en-têtes qu'attendent les endpoints JSON : CSRF, cookies de
 * session, et Accept JSON. `body` objet → JSON.
 */
export function appFetch(url: string, init: JsonInit = {}): Promise<Response> {
  const headers = new Headers(init.headers)
  if (!headers.has('Accept')) headers.set('Accept', 'application/json')
  if (!headers.has('X-CSRF-Token')) headers.set('X-CSRF-Token', csrfToken())
  if (!headers.has('X-Requested-With')) headers.set('X-Requested-With', 'XMLHttpRequest')
  let body = init.body as BodyInit | undefined
  if (init.body !== undefined && !(init.body instanceof FormData) && typeof init.body !== 'string' && !(init.body instanceof URLSearchParams)) {
    headers.set('Content-Type', 'application/json')
    body = JSON.stringify(init.body)
  }
  return fetch(url, { credentials: 'same-origin', ...init, headers, body })
}

export async function getJson<T = any>(url: string, init: JsonInit = {}): Promise<T> {
  const r = await appFetch(url, { ...init, method: 'GET' })
  if (!r.ok) throw new HttpError(r)
  return r.json() as Promise<T>
}

export async function sendJson<T = any>(method: 'POST' | 'PATCH' | 'PUT' | 'DELETE', url: string, body?: unknown, init: JsonInit = {}): Promise<T> {
  const r = await appFetch(url, { ...init, method, body })
  if (!r.ok) throw new HttpError(r)
  const text = await r.text()
  return (text ? JSON.parse(text) : {}) as T
}

export class HttpError extends Error {
  constructor(public response: Response) {
    super(`HTTP ${response.status} ${response.url}`)
  }
}
